<template>
  <div class="container">
    <h1 class="heading">Credits</h1>
    <!-- <h2 class="text-center heading">Thank You!</h2>
    <div class="mb-5">
      <p>
          This recital weekend we celebrate CVPA's 30th year in business and our 29th recital. It is hard to believe that 30 years ago, I sat in a small soon-to-be studio on Santa Maria Avenue and pondered the stories it would tell, the people I would meet, and the experiences we would have.
      </p>
      <p>
          As I sit in our studio today, all I can say is, "Wow!" Never did I dream that the little studio on Santa Maria Avenue would bring 30 years of joy, laughter, and, yes, even a few tears, along with an amazing and constantly growing dance family. I am forever grateful.
      </p>
      <p>
          Over the years, CVPA would become home to thousands of dancers, young and old, who had one thing in common: they love to dance. Today's recital includes children and grandchildren of past students. Many of our teachers were students themselves who grew up in that little studio that opened on Santa Maria Avenue 30 years ago.
      </p>
      <p>
          My heart is full as I watch this large extended dance family come together to celebrate dance and the accomplishments of our amazing students. What an incredible dance family we have!
      </p>
      <p>
          If you are new to the CVPA dance family this year, welcome!! You have joined an amazing community!! The friendships and memories you will make will last a lifetime.
      </p>
      <p>
          Please join us as we celebrate this dance family and our 2023 dancers. The students, teachers, parents, and staff who have worked diligently behind the scenes to bring this recital to life are eager to share their hard work with you. It's their time to shine!
      </p>
      <p>
          <b>*Charlene Horn -</b> What a ride this year has been! Thank you so much for all your help and friendship. There are no words that can even describe how grateful I am. This year we need to make more time and enjoy some crazy adventures. You know, if something goofy is going to happen, it will, and we can laugh for days. I miss those times. Thank you again, for always being there. I appreciate and love you and Larry more than you will ever know. Now let's have some fun!!!
      </p>
      <p>
          <b>*Kim Mihalyi -</b> The strength, grace and dignity you have shown while navigating the most difficult loss have been an inspiration to all of us and a testament to who you are. During moments when our hearts were breaking for you, your inner strength has been such a guiding light for those around you. I am forever grateful to you and to Robbie for your friendship and love. I cherish our memories and am so thankful for you both. Today, as I watch this recital, I see your girls in it, your hard work, and so much of Robbie. You are all such a big part of our dance family and my own family personally.  Your unwavering support and presence have meant the world to me, and I want you to know that I am here for you as well, always! I love you!
      </p>
      <p>
          <b>*Kathy Eshtehar -</b> Your support, encouragement and friendship mean so much to me!! You are constantly putting in extra hours, running to my house to pick-up packages and doing whatever you can to make our life at the studio better!! I am so very grateful!! I consider you my family and am so very thankful to have you in my life!!
      </p>
      <p>
          <b>*To all the teachers and staff -</b> I am so grateful for each one of you. Your love for dance is evident in every class that you teach. Your undying energy, dedication, and encouragement to your students has given them the confidence to step beyond themselves. Our CVPA students are truly blessed! I am so thankful for all of you and for your hard work and dedication. Thank you for making CVPA a wonderful place to be!!
      </p>
      <p>
          <b>*And to all of the students -</b> You have touched our hearts in so many ways. We could not be prouder of you. You bring light and joy to every class and make our job so much fun. Today is your day to shine, so put on your dancing shoes and let your light shine bright!! We are so proud of you!!
      </p>
    </div> -->
    <div class=" text-center">
      <h2 class="heading">Faculty</h2>
      <div class="mb-5">
        <div>Nicole Arevalo</div>
        <div>Alexa Barron Ziegler</div>
        <div>Sofia Barrientos</div>
        <div>Julie Bennett</div>
        <div>Alex Bland</div>
        <div>Karmella Cheatham</div>
        <div>Cailey Chin</div>
        <div>Pame Cortes Ortiz</div>
        <div>Brittany Boole Davidson</div>
        <div>Gia Delatorre</div>
        <div>Alexis Erickson</div>
        <div>Keira Ebrahimi</div>
        <div>Aylin Fonseca</div>
        <div>Erica Hartano</div>
        <div>Avery Koning</div>
        <div>Dallas Martin</div>
        <div>Ava Ng</div>
        <div>Eva Barnezet Parrish</div>
        <div>Kim Pereira</div>
        <div>Gia Solari</div>
        <div>Janet Taddie</div>
        <div>Tian Tan</div>
        <div>Jenelle Vallortigara</div>
        <div>Karisa Vallortigara</div>
        <div>Mandy Whitby</div>
        <div>Erin Yarbrough</div>
      </div>

      <!-- <h2 class="heading">Teacher Assistants</h2>
      <div class="mb-5">
        Alex Bland, Mia Cavicchi, Ashley Chen, Cailey Chin, Mireille Chiv, Isabella Deschler, Maddy Dunster, Alexis
        Erickson, Stephanie Feng, Aylin Fonseca, Naomi Goodwin, Gabriella Gonzales, Quinn Huerta-Pasqua, Malaya Galvez,
        Madeline Jin, Elsa Lee, Somaya Panjwani, Amelia Yamboa, Elle Young, Emme Young
      </div>

      <div class="mb-5">
        <div><b>Curriculum and Choreography Managers -</b> Gia Solari and Kristina Dresen</div>
        <div><b>Student Evaluation Coordinator -</b> Kim Pereira</div>
        <div><b>Administrative Assistants -</b> Kim Mihalyi, Kathy Eshtehar</div>
        <div><b>Bookkeeper -</b> Charlene Horn</div>
      </div> -->

      <h2 class="heading">Production Staff</h2>
      <div class="mb-5">
        <div><b>Costumes -</b> Crystal Zhang, Melody Klever, Kathy Eshtehar</div>
        <div><b>Recital T-shirts -</b> Carleen's T-Shirt Corner</div>
        <div><b>Senior Gala Photos and Photoshoot -</b> Megan Trant Photography</div>
        <div><b>Stage Manager -</b> Gia Solari</div>
        <div><b>Slide Show -</b> Cassie Nordgren</div>
        <div><b>Programs -</b> Alicia Hew, Kharpoh Chen, Charlene Horn</div>
        <div><b>Graphic Designs -</b> Cassie Nordgren</div>
        <div><b>Production Manager -</b> Gia Solari</div>
        <div><b>Bookkeeper -</b> Charlene Horn</div>
        <div><b>Office Manager -</b> Kim Mihalyi</div>
        <div><b>Parent Dance Choreography -</b> Aylin Fonseca, Avery Koning</div>
      </div>

      <p>Special thanks to Devin Gregory, Tim Allen, the Douglas Morrisson Theater Staff and the Hayward Area Recreation Department for making this possible. Thank you to StudioOne Photography for providing the senior yearbook pictures!</p>
      <p>This Senior Gala would not be possible without your help and support.</p>
      <p class="py-20">THANK YOU!!! THANK YOU!!! THANK YOU!!!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Credits",
  components: {},
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>
